<template>
	<div>
		<Modal
			:is-open="isOpen"
			title="Hard delete user request confirmation"
			@close="closeModal"
		>
			<template #body>
				<div class="delete-confirmation">
					<div class="warning-icon">⚠️</div>
					<h3>Are you sure?</h3>
					<p>This will send an email to the user to confirm complete hard deletion of their account.</p>
					<div v-if="message" class="message" :class="{ 'error': isError, 'success': !isError }">
						{{ message }}
					</div>
				</div>
			</template>

			<template #actions>
				<button @click="closeModal" :disabled="sending">Cancel</button>
				<button class="danger" @click="askUser(true)" :disabled="sending">
					{{ sending ? 'Sending...' : 'Send Email' }}
				</button>
			</template>
		</Modal>
	</div>
</template>

<script>
import Modal from './Modal.vue';
import util from '@/util';

export default {
	name: 'delete-user-modal',
	props: {
		isOpen: {
			type: Boolean,
			default: false
		},
		userId: {
			type: Number,
		}
	},
	components: {
		Modal
	},
	store: ['users'],
	data() {
		return {
			sending: false,
			message: null,
			isError: false
		}
	},
	computed: {
		user() {
			return this.users[this.userId] || {
				user_uuid: null
			}
		}
	},

	methods: {
		closeModal() {
			if (!this.sending) {
				this.message = null;
				this.isError = false;
				this.$emit('close');
			}
		},

		askUser(send) {
			this.message = null;
			this.isError = false;

			if (send) this.sending = true;

			let requestParams = {timeout: 40000};
			this.$http.post('/users/' + this.user.user_uuid + '/hardDeleteRequest', {send: send}, requestParams)
				.then((response) => {
					this.sending = false;
					if (!send) {
						this.message = response.data.url;
					} else {
						this.message = 'Request sent successfully!';
						// Auto close after success
						setTimeout(() => {
							this.closeModal();
						}, 2000);
					}
				})
				.catch((error) => {
					this.sending = false;
					this.message = error.message || 'An error occurred';
					this.isError = true;
					console.log(error);
				});
		},

		formatDate(date) {
			return util.formatDate(date);
		}
	}
}
</script>

<style scoped>
	.danger {
		background: #dc3545;
	}

	.danger:hover {
		background: #b70e0e;
	}

	.delete-confirmation {
		text-align: center;
		padding: 20px 0;
	}

	.warning-icon {
		font-size: 48px;
		margin-bottom: 16px;
	}

	.delete-confirmation h3 {
		margin: 0 0 16px 0;
		font-size: 20px;
		color: #333;
	}

	.delete-confirmation p {
		color: #666;
		line-height: 1.5;
		margin-bottom: 20px;
	}

	.message {
		padding: 12px;
		border-radius: 4px;
		margin-top: 16px;
	}

	.message.success {
		background: #d4edda;
		color: #155724;
		border: 1px solid #c3e6cb;
	}

	.message.error {
		background: #f8d7da;
		color: #721c24;
		border: 1px solid #f5c6cb;
	}
</style>
